import gql from "graphql-tag";

export const VIEW_PROFILE = gql`
  query userWithCouncilProfile {
    users {
      id
      full_name
      email
      mobile_number
      is_profile_setup
      council_profile {
        id
        name
        population
        state
        description
        council_cover_path
        council_cover_photo
        council_profile_path
        council_profile_photo
        email
        mobile_number
        website
      }
    }
  }
`;
